import {TranslatedKeys} from 'shared/types/translated-keys';

import {translatedUserProps} from 'modules/users/types';

import {translatedCategoryProps} from 'modules/categories/types';
import {translatedAddressProps} from 'modules/addresses/types';
import {
  translatedCompanyNeighborHoodPriceProps,
  translatedCompanyProps,
  translatedWorkingPeriodProps,
} from 'modules/companies/types';
import {translatedSubCategoryProps} from 'modules/sub-categories/types';
import {
  translatedCityProps,
  translatedDistanceProps,
} from 'modules/cities/types';
import {translatedNeighborhoodProps} from 'modules/neighborhoods/types';
import {translatedSegmentProps} from 'modules/segments/types';
import {
  translatedAdditionalGroupConfigProps,
  translatedProductProps,
  translatedSaleProps,
  translatedSizeProps,
} from 'modules/products/types';
import {translatedPaymentMethodProps} from 'modules/payment-methods/types';
import {translatedCouponProps} from 'modules/coupons/types';
import {translatedNotificationProps} from 'modules/notifications/types';
import {translatedAdditionalGroupProps} from 'modules/additional-groups/types';
import {translatedAdditionalProps} from 'modules/additionals/types';
import {translatedOrderProps} from 'modules/orders/types';
import {translatedBillingProps} from 'modules/billings/types';
import {translatedPermissionGroupProps} from 'modules/permission-groups/types';
import {translatedAccessControlProps} from 'modules/access-controls/types';
import {translatedLogProps} from 'modules/logs/types';
import {translatedBaseAdditionalProps} from 'modules/base-additionals/types';
import {translatedBaseAdditionalGroupProps} from 'modules/base-additional-groups/types';
import {translatedDeliveryManBillingProps} from 'modules/delivery-man-billings/types';
import {
  translatedAdditionalReportProps,
  translatedProductReportProps,
  translatedUsersReportProps,
} from 'modules/reports/types';
import {translatedInvoiceProps} from 'modules/invoices/types';
import {translatedCouponRedemptionProps} from 'modules/coupon-redemptions/types';
import {translatedWhatsappDeliveryErrorProps} from 'modules/whatsapp-delivery-errors/types';

export type TranslationKeyProps<T = any> =
  | TranslatedKeys<T>
  | keyof typeof translatedProps;

export const translatedProps = {
  CategoryProps: translatedCategoryProps,
  SubCategoryProps: translatedSubCategoryProps,
  UserProps: translatedUserProps,
  PermissionGroupProps: translatedPermissionGroupProps,
  AddressProps: translatedAddressProps,
  CompanyProps: translatedCompanyProps,
  CityProps: translatedCityProps,
  NeighborhoodProps: translatedNeighborhoodProps,
  SegmentProps: translatedSegmentProps,
  ProductProps: translatedProductProps,
  PaymentMethodProps: translatedPaymentMethodProps,
  CouponProps: translatedCouponProps,
  NotificationProps: translatedNotificationProps,
  workingPeriodProps: translatedWorkingPeriodProps,
  AdditionalGroupProps: translatedAdditionalGroupProps,
  AdditionalProps: translatedAdditionalProps,
  SizeProps: translatedSizeProps,
  AdditionalGroupConfigProps: translatedAdditionalGroupConfigProps,
  OrderProps: translatedOrderProps,
  SaleProps: translatedSaleProps,
  DistanceProps: translatedDistanceProps,
  BillingProps: translatedBillingProps,
  AccessControlProps: translatedAccessControlProps,
  CompanyNeighborhoodPriceProps: translatedCompanyNeighborHoodPriceProps,
  LogProps: translatedLogProps,
  BaseAdditionalProps: translatedBaseAdditionalProps,
  BaseAdditionalGroupProps: translatedBaseAdditionalGroupProps,
  DeliveryManBillingProps: translatedDeliveryManBillingProps,
  ProductReportProps: translatedProductReportProps,
  UserReportProps: translatedUsersReportProps,
  AdditionalReportProps: translatedAdditionalReportProps,
  InvoiceProps: translatedInvoiceProps,
  CouponRedemptionProps: translatedCouponRedemptionProps,
  WhatsappDeliveryErrorProps: translatedWhatsappDeliveryErrorProps,
};
